import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UzurvDirectivesModule, UzurvPipesModule } from '@uzurv/core';
import { OnDemandRideDialogComponent } from './on-demand-ride-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    UzurvDirectivesModule,
    UzurvPipesModule,
    MatSelectModule,
    FormsModule
  ],
  exports: [OnDemandRideDialogComponent],
  declarations: [OnDemandRideDialogComponent]
})
export class OnDemandRideDialogModule {}
